/*
*   ��װ��ά��ɨ����¼��ѯ�����߼�
*   ���ó�����
*       1.��ά��ɨ����½
*       2.������֤��½����
*       3.�����һ��Ż�����
*
*   dependence:
*       1.jquery
* */

(function(global, factory) {
    if (typeof define === 'function' && define.amd) {
        // Register as an anonymous AMD module:
        define(['jquery'], function($) {
            return factory(global, $);
        });
    } else if (typeof module === "object" && typeof module.exports === "object") {
        // Node/CommonJS:
        module.exports = factory(global, require('jquery'));
    } else {
        // Browser globals:
        factory(global, window.jQuery);
    }
})(typeof window !== 'undefined' ? window : this, function(window, $) {
    function pollStore(options) {
        var xhr = null; // �첽��������
        var isOn = false; //
        var interval = null; //

        options = $.extend({
            topic: '',                   // ��ѯ·��
            interval: 5000,              // ��ѯ����5��
            timeout: 5000,                // ������ʱʱ��5��
            successCallback: $.noop(),  // �����ɹ��ص�����
            errorCallback: $.noop()     // ���������ص�����
        }, options || {});

        function _isFunction(callback) {
            return typeof callback == 'function';
        }

        this.subscribe = function() {
            var self = this;
            if (isOn) return false;
            if (!options.topic) return false;

            interval = setInterval(function() {
                xhr = $.ajax({
                    url: options.topic,
                    data: options.data || '',
                    headers: {Accept: 'text/x-json'},
                    contentType: 'text/x-json',
                    type: 'post',
                    timeout: options.timeout
                }).done(function(data, textStatus, jqXHR) {
                    data = data || {};
                    if (data.code === 'S_OK') { // ������ΪS_OK
                        _isFunction(options.successCallback) &&
                            options.successCallback(data['var'] || {});
                    } else {
                        if (data.code == 'FA_INVALID_SESSION') { // sessionʧЧ�������£��Զ�ȡ������
                            self.unSubscribe();
                        }
                        _isFunction(options.errorCallback) &&
                            options.errorCallback(data, textStatus, jqXHR);
                    }
                }).fail(function(data, textStatus, jqXHR) {
                    _isFunction(options.errorCallback) &&
                        options.errorCallback(data, textStatus, jqXHR);
                });
            }, options.interval);

            isOn = true;

            return this;
        };

        // ��ֹ��ѯ
        this.unSubscribe = function() {
            interval && clearInterval(interval);
            if (xhr) {
                xhr.abort();
                xhr = null;
            }
        };
    }
    window.PollStore = pollStore;
    return pollStore;
});



/*****************
 ** WEBPACK FOOTER
 ** ./web/coremail.cmxt/common/assets/@project.revision@/js/pollstore.js
 ** module id = 158
 ** module chunks = 15
 **/